export const isValidPhoneNumber = phoneNr => /^(9|5|4)\d{7}$/.test(`${phoneNr}`.trim());

export const isValidEmail = email =>
    /^[-!#$%&'*+/=?^_`{|}~A-Za-z0-9]+(?:\.[-!#$%&'*+/=?^_`{|}~A-Za-z0-9]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9]$/.test(`${email}`.trim());

export const isValidPin = pin => /^\d{4}$/.test(`${pin}`.trim());

export const isValidString = string => typeof string === 'string' && string.trim().length > 1;

export const isValidPassword = string => typeof string === 'string' && string.trim().length >= 8;

export const isValidPostalCode = postalCode => /^\d{4}$/.test(postalCode);
